import { TRootState } from "Redux/Reducers";

export const getLastEventId = (state: TRootState) => state.event.lastUpdateId;
